import Button from "@/Button";
import { format } from "date-fns";
import { EveningIcon, MorningIcon, AfternoonIcon } from "@spoctech/icons";
import Typography from "@/Typography";

interface TimeSection {
  title: string;
  icon: React.ReactNode;
  slots: string[];
}

interface TimeSlotPickerProps {
  selectedDate?: Date;
  selectedTime: string;
  onTimeSelect: (time: string) => void;
  hideHeading?: boolean;
  className?: string;
}

const TimeSlotPicker = (props: TimeSlotPickerProps) => {
  const {
    selectedDate = new Date(),
    selectedTime,
    onTimeSelect,
    hideHeading = false,
    className,
  } = props;

  const timeSections: TimeSection[] = [
    {
      title: "Morning",
      icon: (
        <MorningIcon className="size-6 [&>path]:stroke-[2px] text-primary-main" />
      ),
      slots: ["09:00 am", "10:00 am", "11:00 am"],
    },
    {
      title: "Afternoon",
      icon: (
        <AfternoonIcon className="size-6 [&>path]:stroke-[2px] text-primary-main" />
      ),
      slots: ["12:00 pm", "01:00 pm", "02:00 pm"],
    },
    {
      title: "Evening",
      icon: (
        <EveningIcon className="size-6 [&>path]:stroke-[2px] text-primary-main" />
      ),
      slots: ["03:00 pm", "04:00 pm", "05:00 pm"],
    },
  ];
  return (
    <div className={className}>
      {!hideHeading && (
        <Typography variant="h3" className="mb-6">
          {format(selectedDate, "EEEE, MMMM d")}
        </Typography>
      )}

      <div className="space-y-8">
        {timeSections.map((section) => (
          <div key={section.title}>
            <div className="flex items-center gap-2 mb-4">
              {section.icon}
              <Typography variant="h4" className="!font-regular">
                {section.title}
              </Typography>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {section.slots.map((time) => (
                <Button
                  key={time}
                  onClick={() => onTimeSelect(time)}
                  variant="outlined"
                  fullWidth
                  roundedFull
                  color={selectedTime === time ? "primary" : "gray"}
                  size="small"
                >
                  {time}
                </Button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimeSlotPicker;
